<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full" style="display:flex; background-color: #262d4a" id="more-info_page">
    <div class="vx-col sm:w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/4 mx-auto self-center">
      <!-- <img style="width:100%;" src="https://lateralscaffolding.blob.core.windows.net/resources/logo-if-on-white.png"/> -->
      <vx-card card-background="#11193f" class="glow-effect_white mb-3">
        <div>
          <vs-button v-if="$getSiteId() != 8" id="profile-button" size="small" type="flat" class="glow-effect_primary mt-4 mr-4 px-3 text__school-font-color" @click="viewProfile">Profile</vs-button>
          <span style="display: inline-flex; margin-top: 5px !important;">
            <img id="profileimg" :src="profilePic" width="40%"> <!-- https://forty5degreesstorage.blob.core.windows.net/user/avatar_Another_Student.png -->
            <div>
              <p style="font-size: 18pt;color:white; margin-top: 23px !important; margin-left: 24px !important;" >Hi {{ user_displayName.split(' ')[0] }},</p>
            <p style="font-size: 12pt;color:white; margin-left: 24px;">welcome back!</p></div>
          </span>
        </div>
      </vx-card>

      <vx-card id="language_card" class="glow-effect_dark mb-3 card__no-padding bg-color">
        <vx-input-group id="language_inputgroup">
          <template slot="prepend">
            <div class="prepend-text school-primary_gradient">
              <span><feather-icon class="pt-1" id="language-icon" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
            </div>
          </template>

          <v-select 
            ref="languageDropdown"
            class="w-full style-chooser"
            placeholder="My Preferred Language"
            :options="languages"
            @search:blur="selectLanguage"
            v-model="languageDropdown"
          />
        </vx-input-group>
      </vx-card>

      <vx-card id="grade_card" v-show="languageDropdown" class="glow-effect_dark mb-3 card__no-padding bg-color">
        <vx-input-group id="grade_inputgroup">
          <template slot="prepend">
            <div class="prepend-text school-primary_gradient">
              <span><feather-icon class="pt-1" id="grade-icon" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
            </div>
          </template>

          <v-select
            ref="classificationDropdown"
            class="w-full style-chooser"
            placeholder="My Current Grade"
            :options="classifications"
            v-model="classificationDropdown"
          />
        </vx-input-group>
      </vx-card>

      <vx-card id="continue-watching_card" v-show="classificationDropdown" class="glow-effect_dark card__no-padding bg-color">
        <vx-input-group id="grade_inputgroup">
          <template slot="prepend">
            <div class="prepend-text bg-color">
              <span><feather-icon class="pt-1" id="grade-icon" icon="ArrowRightIcon" svg-classes="stroke-current"></feather-icon></span>
            </div>
          </template>

          <vs-button
            v-if="!publicredirect"
            ref="continueWatchingBtn"
            size="large"
            class="w-full glow-effect_primary school-primary_gradient"
            style="border-radius:0 7px 7px 0"
            @click="continueWatching">
            Continue
          </vs-button>

          <vs-button
            v-if="publicredirect"
            ref="continueWatchingBtn"
            size="large"
            class="w-full glow-effect_primary school-primary_gradient"
            style="border-radius:0 7px 7px 0"
            @click="setLangAndGrade">
            Continue
          </vs-button>
        </vx-input-group>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data() {
    return {
      languageId: null,
      courseClassificationId: null,
      languageDropdown: 0,
      classificationDropdown: 0,
      languages: [],
      classifications: [],
      publicredirect: false,
    };
  },
  computed: {
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null ? JSON.parse(localStorage.getItem("userInfo")).displayName.split('(')[0] : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    profilePic() {
      return (localStorage.getItem('pictureUrl') == null || localStorage.getItem('pictureUrl') == "null" || localStorage.getItem('pictureUrl') == "undefined" || localStorage.getItem('pictureUrl') == "") ? "https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" : localStorage.getItem('pictureUrl');
    }
  },
  mounted() {
    var self = this;
    self.checkRef();
    self.$store.dispatch("updateTheme", "dark");
    self.getLanguages();
  },
  created() {
    document.title = "DigiCampus";
  },
  methods: {
    selectLanguage() {
      var self = this;
      if (!self.languageDropdown) return;
      if(self.classifications.length == 0)
        self.getClassifications(function () { self.classificationDropdown = 0; });
    },
    getLanguages() {
      var self = this;

      var onSuccess = response => {
        self.languages = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "language/GetSelectList", onSuccess);
    },
    getClassifications(onSuccessIn) {
      var self = this;

      var onSuccess = response => {
        self.classifications = response.data.map((item) => { return { label: item.text, value: item.value } });
        onSuccessIn();
      };

      self.$ajaxGet(self, "courseclassification/GetSelectList/" + self.languageDropdown.value, onSuccess);
    },
    viewProfile() {
      let routeData = this.$router.resolve({ name: "DigiStudentProfile" });
      window.open(routeData.href, "_blank");
    },
    continueWatching() {
      var self = this;
      self.showLoadingOnElement('continueWatchingBtn', 0.55, 'default', '#52b75d')
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));

      userInfo.languageId = parseInt(self.languageDropdown.value);
      userInfo.courseClassificationId = parseInt(self.classificationDropdown.value);

      localStorage.setItem('userInfo', JSON.stringify(userInfo));

      self.updateLanguageAndGrade();

      self.$router.push({ name: 'BrowseContent' });
    },
    updateLanguageAndGrade() {
      var self = this;

      var onSuccess = response => {};
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.continueWatchingBtn.$el);
      };

      self.$ajaxGet(self, "Student/UpdateLanguageAndGrade?languageId=" + self.languageDropdown.value + "&classificationId=" + self.classificationDropdown.value, onSuccess, onFinally);
    },
    stopLoading() {
      this.$vs.loading.close(this.$refs.login.$el);
    },
    showLoadingOnElement(element, scale, type, color) {
      var self = this;
      self.$vs.loading({
        color: color,
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    checkRef(){
      var self = this;
      if(self.$route.query.public){
        self.publicredirect = true;
      }
      if(self.$refs.continueWatchingBtn){
        self.$vs.loading.close(self.$refs.continueWatchingBtn.$el);
      }
    },
    setLangAndGrade(){
      var self = this;
      var onSuccess = response =>{
        var userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo.languageId = parseInt(self.languageDropdown.value);
        userInfo.courseClassificationId = parseInt(self.classificationDropdown.value);
        
        if (userInfo.sitePermissions.filter(function(x) {return x.siteId == 36}).length > 0) {
          userInfo.sitePermissions.filter(function(x) {return x.siteId == 36})[0].languageId = parseInt(self.languageDropdown.value);
          userInfo.sitePermissions.filter(function(x) {return x.siteId == 36})[0].courseClassificationId = parseInt(self.classificationDropdown.value)
        }

        if (userInfo.sitePermissions.filter(function(x) {return x.siteId == 31}).length > 0) {
          userInfo.sitePermissions.filter(function(x) {return x.siteId == 31})[0].languageId = parseInt(self.languageDropdown.value);
          userInfo.sitePermissions.filter(function(x) {return x.siteId == 31})[0].courseClassificationId = parseInt(self.classificationDropdown.value)
        }

        if (userInfo.sitePermissions.filter(function(x) {return x.siteId == self.$getSiteIdWithContent()}).length > 0) {
          userInfo.sitePermissions.filter(function(x) {return x.siteId == self.$getSiteIdWithContent()})[0].languageId = parseInt(self.languageDropdown.value);
          userInfo.sitePermissions.filter(function(x) {return x.siteId == self.$getSiteIdWithContent()})[0].courseClassificationId = parseInt(self.classificationDropdown.value);
        }

        localStorage.setItem("userInfo", JSON.stringify(userInfo));

        window.location.replace("digi/browsecontent?ref=public");
      }
    
      var onFinally = response =>{
      }
    
      self.$ajaxPost(self,"Student/Public/UpdateLanguageAndGrade?languageId=" + self.languageDropdown.value + "&classificationId=" + self.classificationDropdown.value ,null, onSuccess, onFinally);
    },
  }
};
</script>
